
const handleSubmit = async (values) => {
  console.log('submit in resource')
}

export default handleSubmit
